import React from 'react'
import { withIcon } from '../../withIcon'

const VIEWBOX_W = 11
const VIEWBOX_H = 17

function toHeightPx (size) {
  if (typeof size === 'number') return size
  const n = parseFloat(String(size).replace(/px$/i, ''))
  return Number.isFinite(n) ? n : 24
}

function LearnerLevelAdvancedIcon (props) {
  const {
    size = 24,
    color = '#000000',
  } = props

  const heightPx = toHeightPx(size)
  const widthPx = heightPx * (VIEWBOX_W / VIEWBOX_H)

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={`${widthPx}px`} height={`${heightPx}px`} viewBox={`0 0 ${VIEWBOX_W} ${VIEWBOX_H}`} fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.80558 10.5391C5.23751 10.1871 5.87462 10.212 6.27726 10.6143L10.6777 15.0147C11.1072 15.4443 11.1072 16.1408 10.6777 16.5703C10.2481 16.9999 9.55155 16.9999 9.12199 16.5703L5.49992 12.9483L1.87785 16.5703C1.44832 16.9999 0.751771 16.9998 0.322183 16.5703C-0.107394 16.1408 -0.107394 15.4443 0.322183 15.0147L4.72257 10.6143L4.80558 10.5391ZM4.80558 5.39554C5.23752 5.04354 5.87463 5.0684 6.27726 5.47074L10.6777 9.87113C11.1072 10.3007 11.1072 10.9972 10.6777 11.4268C10.2481 11.8563 9.55154 11.8563 9.12199 11.4268L5.49992 7.80472L1.87785 11.4268C1.44832 11.8563 0.751772 11.8562 0.322183 11.4268C-0.107394 10.9972 -0.107394 10.3007 0.322183 9.87113L4.72257 5.47074L4.80558 5.39554ZM4.80558 0.246128C5.23756 -0.105892 5.87464 -0.0801423 6.27726 0.3223L10.6777 4.72269C11.107 5.15229 11.1072 5.84883 10.6777 6.27835C10.2481 6.70773 9.55153 6.70771 9.12199 6.27835L5.49992 2.65531L1.87785 6.27835C1.44836 6.70779 0.751765 6.70764 0.322183 6.27835C-0.107375 5.84879 -0.107336 5.15228 0.322183 4.72269L4.7216 0.3223L4.80558 0.246128Z"
        fill={color}
      />
    </svg>
  )
}

export default withIcon(LearnerLevelAdvancedIcon)
